import { render, staticRenderFns } from "./StoreProductList.vue?vue&type=template&id=140b7b21&"
import script from "./StoreProductList.vue?vue&type=script&lang=js&"
export * from "./StoreProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports